<template>
	<q-btn flat dense size="lg">
		<flag :iso="nameLanguageSelected" size="3rem" />
		<q-popover>
			<q-list link separator class="scroll" style="min-width: 100px">
				<q-item
					v-for="(language, index) in languages"
					:key="index"
					v-close-overlay
					@click.native="changeIdiom(language.id)"
				>
					<flag :iso="language.country_flag" size="1.5rem" style="margin-right: 3px" />
					<q-item-main :label="language.name" />
				</q-item>
			</q-list>
		</q-popover>
	</q-btn>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	data() {
		return {}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			id_user_campaign_selected: 'common/id_user_campaign_selected',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			id_user_client_selected: 'common/id_user_client_selected',
			id_user_language_selected: 'common/id_user_language_selected',
			languages: 'params/languages',
			login_default_language_id: 'params/login_default_language_id',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		nameLanguageSelected() {
			let obj = this.languages.find((obj) => obj.id === this.id_user_language_selected)
			if (obj) {
				return obj.country_flag
			} else {
				this.changeIdiom(this.login_default_language_id)
				return ''
			}
		},
	},
	methods: {
		changeIdiom(code) {
			this.$store.dispatch('common/SET_LANGUAGE', [code])
			this.setUserSelection()
			this.clearDatatables()

			const language = this.languages.find((l) => l.id === code)

			this.$changeWaLocal(language.code === 'pt-br' ? 'br-pt' : language.code)
		},

		clearDatatables() {
			this.$q.localStorage.remove('dataTableTags')
			this.$q.localStorage.remove('dataTableTrainings')
			this.$q.localStorage.remove('dataTableTrals')
			this.$q.localStorage.remove('dataTablelibraryCategories')
			this.$q.localStorage.remove('dataTableLibraries')
			this.$q.localStorage.remove('dataTableWebcast')
			this.$q.localStorage.remove('15-user-columns')
			this.$q.localStorage.remove('dataTableUsersGroups')
			this.$q.localStorage.remove('dataTableBranches')
			this.$q.localStorage.remove('dataTableQuestions')
			this.$q.localStorage.remove('dataTableTask')
			this.$q.localStorage.remove('dataTableSurveys')
			this.$q.localStorage.remove('dataTableMessages')
			this.$q.localStorage.remove('dataTableNews')
			this.$q.localStorage.remove('dataTableFaq')
			this.$q.localStorage.remove('dataTableFaqCategories')
			this.$q.localStorage.remove('dataTableBanners')
			this.$q.localStorage.remove('dataTableBannerWelcome')
		},

		setUserSelection() {
			this.$q.loading.show()

			let fd = new FormData()
			fd.append('client', this.id_user_client_selected)
			fd.append('country', this.id_user_client_country_selected)
			fd.append('language', this.id_user_language_selected)
			fd.append('campaign', this.id_user_campaign_selected)

			this.$axios
				.post('/accounts/set_user_selection/', fd, this.getHeader)
				.then((response) => {
					const d = response.data

					this.$store.dispatch('common/SET_USER_DATA', [
						d.id,
						d.id_user_client_profile,
						d.full_name,
						d.document,
						d.id_user_client_selected,
						d.id_user_client_country_selected,
						d.id_user_language_selected,
						d.user_clients,
						d.user_client_module_items,
						d.user_modules,
						d.user_module_items,
						d.user_firebase_document,
						d.is_superuser,
						d.email,
						d.user_firebase_document_ranking_areas,
						d.has_mandatory_surveys,
						d.accept_terms_and_conditions,
						d.user_companies,
						d.user_branches,
						d.id_user_campaign_selected,
					])

					this.languages.filter((e) => {
						if (e.id == this.id_user_language_selected) {
							this.name_language_selected = {
								code: e.code,
								country_flag: e.country_flag,
								id: e.id,
								name: e.name,
							}
						}
					})
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},
	},

	watch: {
		id_user_language_selected: function(val) {
			const language = this.languages.find((l) => l.id === this.id_user_language_selected)

			if (language) {
				let code = ''

				switch (language.code) {
					case 'es-es':
						code = language.code.split('-')[0]
						break
					case 'fr-fr':
						code = language.code.split('-')[0]
						break
					default:
						code = language.code
						break
				}

				import(`quasar-framework/i18n/${code}`).then((lang) => {
					this.$q.i18n.set(lang.default)
				})

				this.$changeWaLocal(language.code === 'pt-br' ? 'br-pt' : language.code)
				this.$i18n.i18next.changeLanguage(language.code.split('-')[0])
			} else {
				import('quasar-framework/i18n/pt-br').then((lang) => {
					this.$q.i18n.set(lang.default)
				})

				this.$i18n.i18next.changeLanguage('pt')
			}
		},
	},
}
</script>

<style></style>
